export default "__VITE_ASSET__Dcwr2F39__"